import { useState } from 'react';
import { mostrarError, mostrarExito } from '../../utils/Alertas';
import { Typography, TextField } from '@mui/material';
import './css/Contacto.css'

const Contacto = () => {
    const [form, setForm] = useState({
        nombre: '',
        email: '',
        telefono: '',
        mensaje: '',
    });
    const [enviando, setEnviando] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (enviando) return;
        setEnviando(true);

        try {
            const response = await fetch('https://us-central1-morrisyluna.cloudfunctions.net/enviarContacto',
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(form),
                }
            );

            if (response.ok) {
                setForm({ nombre: '', email: '', telefono: '', mensaje: '' });
                mostrarExito('Gracias por tu mensaje. Te responderemos pronto.');
            } else {
                mostrarError('Error al enviar el mensaje. Inténtalo más tarde.');
            }
        } catch (error) {
            mostrarError('Ocurrió un error inesperado. Intenta nuevamente.');
        } finally {
            setEnviando(false);
        }
    };

    return (
        <div className="container-fluid contacto-page">
            <div className="text-center">
                <h2>Contáctanos</h2>
            </div>
            <div className="container-fluid">
                <Typography variant="body1" align="center" color="text.secondary" mb={2}>
                    ¿Tienes dudas, propuestas o simplemente quieres saludar? ¡Escríbenos!
                </Typography>

                <form onSubmit={handleSubmit} className="form-contacto">
                    <TextField
                        fullWidth
                        label="Nombre"
                        name="nombre"
                        value={form.nombre}
                        onChange={handleChange}
                        required
                        margin="normal"
                    />
                    <TextField
                        fullWidth
                        type="email"
                        label="Correo electrónico"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        required
                        margin="normal"
                    />
                    <TextField
                        fullWidth
                        label="Teléfono (opcional)"
                        name="telefono"
                        value={form.telefono}
                        onChange={handleChange}
                        margin="normal"
                    />
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        label="Mensaje"
                        name="mensaje"
                        value={form.mensaje}
                        onChange={handleChange}
                        required
                        margin="normal"
                    />

                    <button className="main-button" type="submit" disabled={enviando}>{enviando ? 'Enviando...' : 'Enviar'}</button>
                </form>
            </div>
        </div>
    );
};

export default Contacto;
